import React, {Component} from 'react';
import './style/list.css';

class List extends Component {
    constructor(props) {
        super(props);
        this.title = props.title;
        this.name = props.name;
        this.placeholder = props.placeholder;
        this.removeItem = this.removeItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.state = {
            newMail: '',
            btnDisabled: true,
        };
    }

    validationEmail(email){
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    }

    onChange() {
        this.props.onChange({
            target: {
                name: this.name,
                value: this.props.value,
            }
        });
    }

    onChangeText(e) {
        this.setState({
            ...this.state,
            btnDisabled: !this.validationEmail(e.target.value) || this.props.value.indexOf(e.target.value) > -1,
            newMail: e.target.value
        });
    }

    removeItem(e, key) {
        const keyIndex = this.props.value.indexOf(key);

        e.preventDefault();
        if (keyIndex > -1) {
            this.props.value.splice(keyIndex, 1);
            this.onChange();
        }
    }

    addItem(e) {
        e.preventDefault();
        if (this.state.newMail && this.props.value.indexOf(this.state.newMail) === -1) {
            this.props.value.push(this.state.newMail);
            this.setState({
                ...this.state,
                btnDisabled: true,
                newMail: e.target.value
            });
            this.onChange();
        }
    }

    render() {
        return (
            <div className="fieldWrapper">
                <label htmlFor={this.name}>
                    {this.title || this.name}
                </label>
                <div className="list" name={this.name}>
                    <div className="line selectsWrapper">
                        <input
                            type="email"
                            placeholder={this.placeholder || "Enter e-mail address"}
                            id={this.name}
                            name={this.name}
                            value={this.state.newMail}
                            onChange={this.onChangeText}
                        />
                        <button className="addItem icon" onClick={this.addItem}
                                disabled={this.state.btnDisabled}> </button>
                    </div>
                    {(this.props.value.length) ? this.props.value.map(
                        (fieldKey, i) => <div className="line" key={i}>
                            <div className='val-value'>{fieldKey}</div>
                            <button className="removeItem icon" onClick={(e) => this.removeItem(e, fieldKey)}></button>
                        </div>
                    ) : <span></span>}
                </div>
            </div>
        );
    }
}


export default List;
